
import theme from '@/assets/theme.scss';
import { lightweightChartMixin } from '@/mixins';

export default {
    name: 'VolatilityIndexChart',

    mixins: [lightweightChartMixin],

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            chart: null,
        }
    },

    watch: {
        isDarkMode: {
            immediate: true,
            handler(newState) {
                this.updateLineSeriesStyle(newState)
            }
        },
        data: {
            immediate: true,
            handler() {
                if (this.chart) {
                    this.drawChart()
                }
            }
        },
    },

    mounted() {
        this.createChart({ height: 200 })
        this.drawChart()
    },

    methods: {
        drawChart() {
            if (this.lineSeries) {
                this.lineSeries.setData((this.data.datapoints ?? []).map(datapoint => {
                    return {
                        time: this.getTimezoneCorrectedTime(datapoint.t, true),
                        value: datapoint.c
                    }
                }));

                this.chart.timeScale().fitContent();

                return;
            }

            this.lineSeries = this.chart.addLineSeries({ lineWidth: 2, color: this.isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light'], lineType: 2 });
            this.lineSeries.setData((this.data.datapoints ?? []).map(datapoint => {
                return {
                    time: this.getTimezoneCorrectedTime(datapoint.t, true),
                    value: datapoint.c
                }
            }));

            this.chart.timeScale().fitContent();
        },
        updateLineSeriesStyle(isDarkMode) {
            this.lineSeries?.applyOptions({ color: isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light'] })
        }
    },
}
